import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  private permissions$: Observable<string[]>;

  constructor(private store: Store<any>) {
    this.permissions$ = this.store.select(state => state.auth?.permissions || []);
  }

  /**
   * Check if user has specific permission
   *
   * @param permission Permission to check
   * @returns Observable<boolean>
   */
  hasPermission(permission: string): Observable<boolean> {
    return this.permissions$.pipe(
      map(permissions => Array.isArray(permissions) && permissions.includes(permission))
    );
  }

  /**
   * Check if user has any of the specified permissions
   *
   * @param permissions Permissions to check
   * @returns Observable<boolean>
   */
  hasAnyPermission(permissions: string[]): Observable<boolean> {
    return this.permissions$.pipe(
      map(userPermissions =>
        Array.isArray(userPermissions) &&
        permissions.some(permission => userPermissions.includes(permission))
      )
    );
  }

  /**
   * Check if user has all of the specified permissions
   *
   * @param permissions Permissions to check
   * @returns Observable<boolean>
   */
  hasAllPermissions(permissions: string[]): Observable<boolean> {
    return this.permissions$.pipe(
      map(userPermissions =>
        Array.isArray(userPermissions) &&
        permissions.every(permission => userPermissions.includes(permission))
      )
    );
  }

  /**
   * Get all permissions
   *
   * @returns Observable<string[]>
   */
  getAllPermissions(): Observable<string[]> {
    return this.permissions$;
  }
}
